module.exports = __webpack_public_path__ + "img/7.d854e223.jpg";